import "@rainbow-me/rainbowkit/styles.css";
import { RainbowKitProvider, midnightTheme } from "@rainbow-me/rainbowkit";
import { WagmiConfig } from "wagmi";
import { Toaster } from "react-hot-toast";
import { client, chains } from "./components/ClientConfig";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WagmiConfig client={client}>
      <RainbowKitProvider chains={chains} theme={midnightTheme()}>
        <App />
      </RainbowKitProvider>
    </WagmiConfig>
    <Toaster
      containerStyle={{
        bottom: 50,
      }}
    />
  </React.StrictMode>
);
